import FileHelper from "@/helpers/FileHelper";

export default {
	methods: {
		async upload(event) {
			const files = event.target.files;
			const res = await FileHelper.upload({files})
			return res && res.data
		},
	}
}